import { Button } from '@breetometer/components';
import { classNameMerger } from '@breetometer/utils';
import { ArrowIcon, ConvertIcon, PlusIcon } from 'BreetAssets';
import { getTargetEnvironment, isSandboxEnvironment } from 'BreetHelpers';
import { useModalApi, usePermissions } from 'BreetHooks';
import { selectIsApprovedForLive, selectUserData, useAppSelector } from 'BreetRedux';
import { createPortal } from 'react-dom';

export const HeaderCTA = ({ bottom }: { bottom?: boolean }) => {
	const { handleOpenModal } = useModalApi();

	const { hasPermission } = usePermissions();

	const isApprovedForLive = useAppSelector(selectIsApprovedForLive);
	const user = useAppSelector(selectUserData);

	const isAdmin = user?.businessRole === 'owner';

	const isKybCompleted =
		!isAdmin || isSandboxEnvironment(getTargetEnvironment()) || !!isApprovedForLive || !!user.approvedForLive;

	const openOnboarding = handleOpenModal({ id: 'onBoardingTodoList', wrapperClassName: 'onboarding-todolist-wrapper' });

	const fundWallet = handleOpenModal({ id: 'fundWallet', variant: 'right-sheet' });
	const withdraw = handleOpenModal({ id: 'requestPayment', variant: 'right-sheet' });
	const convert = handleOpenModal({ id: 'convertCurrency', variant: 'right-sheet' });

	const actionsComponent = ({ isMobile }: { isMobile?: boolean }) => (
		<>
			<Button
				trailingIcon={<PlusIcon />}
				className={classNameMerger(
					'fund',
					isMobile ? 'tertiary-txt-link-hover bg-primary-400-hover color-neutral-50-hover' : 'primary-hover',
					'bg-prim'
				)}
				onClick={isKybCompleted ? fundWallet : openOnboarding}
			>
				Fund Wallet
			</Button>
			<Button
				trailingIcon={<ArrowIcon variant='arrowDown' />}
				className={classNameMerger(
					'withdraw',
					isMobile ? 'tertiary-txt-link-hover bg-primary-400-hover color-neutral-50-hover' : 'tertiary-hover'
				)}
				onClick={isKybCompleted ? withdraw : openOnboarding}
			>
				Withdraw
			</Button>
			<Button
				trailingIcon={<ConvertIcon />}
				className={classNameMerger(
					'convert',
					isMobile ? 'tertiary-txt-link-hover bg-primary-400-hover color-neutral-50-hover' : 'tead-hover'
				)}
				onClick={isKybCompleted ? convert : openOnboarding}
			>
				Convert
			</Button>
		</>
	);

	const actions = hasPermission('payments') && actionsComponent;

	if (!actions) return null;

	if (bottom) {
		return (
			<>
				<div
					className='home-header-cta-spacer'
					aria-hidden='true'
				/>
				{createPortal(
					<div
						className='home-header-cta mobile'
						data-tour='wallet-actions'
					>
						{actions({ isMobile: true })}
					</div>,
					document.body
				)}
			</>
		);
	}

	return (
		<div
			className='home-header-cta desktop'
			data-tour='wallet-actions'
		>
			{actions({})}
		</div>
	);
};
